import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';
import { ArrowRight, Home } from 'lucide-react';
import '@/styles/forms.css';

// 404 page. Emits noindex and NO canonical (never a canonical pointing elsewhere).
// The real 404 HTTP status is set by the server/nginx (see nginx.conf, server.py,
// and public/404.html); this is the client-rendered view once the SPA hydrates.
export default function NotFoundPage() {
  return (
    <div style={{ minHeight: '100vh' }}>
      <SEO
        fullTitle="Page not found (404) | UXAuditPro"
        description="The page you were looking for does not exist."
        noIndex
        noCanonical
      />
      <section className="uxa-pt-xl uxa-pb-xl px-6">
        <div className="max-w-2xl mx-auto text-center">
          <p
            aria-hidden="true"
            style={{
              fontFamily: 'var(--font-numeral)',
              fontSize: 'clamp(64px, 12vw, 120px)',
              lineHeight: 0.86,
              letterSpacing: '-1px',
              color: 'var(--ink-1)',
            }}
          >
            404
          </p>
          <h1
            className="uxa-h1 mt-4 mb-4"
            style={{ color: 'var(--ink-1)' }}
          >
            This page does not exist
          </h1>
          <p className="mb-10" style={{ fontSize: 'var(--type-lead-size)', lineHeight: 'var(--type-lead-leading)', color: 'var(--ink-2)', textWrap: 'pretty' }}>
            The link may be broken or the page may have moved. Head back home, or browse the UX audit guides.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/" className="uxa-submit uxa-submit--auto">
              Back home
              <span className="uxa-submit-knob" aria-hidden="true"><Home className="w-4 h-4" /></span>
            </Link>
            <Link to="/blog/" className="uxa-button-secondary">
              Read the blog <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
